import React from 'react';
import { motion } from 'framer-motion';
import { RefreshCwIcon, XIcon } from 'lucide-react';
interface UpdateNotificationProps {
  onUpdate: () => void;
  onDismiss: () => void;
}
export const UpdateNotification: React.FC<UpdateNotificationProps> = ({
  onUpdate,
  onDismiss
}) => {
  return <motion.div initial={{
    opacity: 0,
    y: 50
  }} animate={{
    opacity: 1,
    y: 0
  }} exit={{
    opacity: 0,
    y: 50
  }} className="fixed bottom-6 right-6 z-50 bg-primary text-white rounded-lg shadow-2xl p-4 max-w-sm" data-id="element-125">
      <div className="flex items-start gap-3" data-id="element-126">
        <RefreshCwIcon className="h-5 w-5 mt-0.5 flex-shrink-0" data-id="element-127" />
        <div className="flex-1" data-id="element-128">
          <h3 className="font-semibold mb-1" data-id="element-129">Update Available</h3>
          <p className="text-sm opacity-90 mb-3" data-id="element-130">
            A new version of IBD Rant is available. Refresh to get the latest
            updates.
          </p>
          <div className="flex gap-2" data-id="element-131">
            <button onClick={onUpdate} className="bg-white text-primary px-4 py-2 rounded-md text-sm font-medium hover:bg-gray-100 transition-colors" data-id="element-132">
              Refresh Now
            </button>
            <button onClick={onDismiss} className="px-4 py-2 rounded-md text-sm font-medium hover:bg-white/10 transition-colors" data-id="element-133">
              Later
            </button>
          </div>
        </div>
        <button onClick={onDismiss} className="text-white/70 hover:text-white transition-colors" aria-label="Dismiss" data-id="element-134">
          <XIcon className="h-5 w-5" data-id="element-135" />
        </button>
      </div>
    </motion.div>;
};